import { api } from "services";

import { IS_DEV } from "globals/constants";
import { userTasks as constants } from "store/constants";
import { actionLoaderFactory } from "store/factories/fetchable";
import store from "store/store";
import { notifyError } from "utils";

const factory = actionLoaderFactory(constants, constants.USER_TASKS);

export const getTasks = async options => {
	return factory.createLoaderAction(
		() => api.tasks.getUserTasks(options),
		[
			response => {
				factory.setData({ userTasks: response });

				return response;
			},
			(error, { getState }) => {
				const message = IS_DEV ? error.message : getState().dictionary.common.userTask.someTasksNotLoaded;

				notifyError(message, error);
				factory.setError(message);
			},
		],
	);
};

/**
 * @param {string} instanceId
 * @param {string} instanceEndpoint
 * @param {{taskType: *, targetName: *, decision: string, comment: string, taskId: *}} payload
 */
export const completeReviewTask = async (instanceId, instanceEndpoint, payload) => {
	try {
		await api.tasks.saveReview({ instanceEndpoint, instanceId }, payload);

		const tasks = await getTasks({ numRetries: 0 });

		const updatedTasks = (tasks || []).filter(({ id }) => id !== payload.taskId);
		factory.setData({ userTasks: updatedTasks });

		return updatedTasks;
	} catch (error) {
		const message = IS_DEV ? error.message : store.getState().dictionary.common.userTask.submitReviewStalls;

		notifyError(message, error);
		throw error;
	}
};

export const completeMultipleReviewTasks = async (instanceId, instanceEndpoint, payload) => {
	try {
		await api.tasks.saveReviews({ instanceEndpoint, instanceId }, payload);

		const tasks = await getTasks({ numRetries: 0 });

		const taskIds = payload.tasks.map(task => task.taskId);
		const updatedTasks = (tasks || []).filter(({ id }) => !taskIds.includes(id));
		factory.setData({ userTasks: updatedTasks });

		return updatedTasks;
	} catch (error) {
		const message = IS_DEV ? error.message : store.getState().dictionary.common.userTask.submitReviewStalls;

		notifyError(message, error);
		throw error;
	}
};
